import { surveyTakeStore } from "../stores";

export const useSurveyTakeStore = () => surveyTakeStore;
